import { Modal, Form, Button } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import DatePiker from "../../datepiker/datePiker";
import useAxios from "../../../services/useAxios";
import AuthenticationContext from "../../../Authentication/AuthenticationContext.ts";
import { CustomInput, ReactSelect } from "../../kits/Inputs/Inputs";

import {
  showSwalQuestion,
  showSwalSuccess,
  showSwalError,
} from "../../../utils/swal";
export default function Reminder({
  show,
  setShow,
  reminderText,
  setReminderText,
  selectedContact,
}) {
  const { userInfo } = useContext(AuthenticationContext);
  const [value, setValue] = useState("");
  useEffect(() => {
    setValue("");
  }, []);
  const handleClose = () => setShow(false);
  const { execute: SendReminder } = useAxios("api/chat_add_reminder");
  const reminder = (date, text) => {
    SendReminder({
      admin_id: userInfo["id"],
      customer_id: selectedContact["customer_id"],
      text: text,
      end_tm: date.unix,
    }).then((result) => {
      handleClose();
      if (!(result.status == 1)) {
        showSwalError("مشکلی پیش آمده لطفا دوباره امتحان کنید");
      }
      if (result.status == 1) {
        showSwalSuccess("یادآور با موفقیت ثبت شد");
      }
    });
  };
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>افزودن یادآور</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>زمان یاد آور: </Form.Label>
              <DatePiker
                setValue={setValue}
                value={value}
                type_calender={"persian"}
                location={"right"}
                color={"blue"}
                // bg={"bg-dark"}
                buttons={true}
                time={false}
                just_time={false}
                onlyYear={false}
                onlyMonth={false}
                hideWeekDays={true}
                hideMonth={false}
                highlightDay={true}
                color_highlight={"red"}
                // disableDay={true}
                weekend={"dis"}
                disableMonthPicker={false}
                disableYearPicker={false}
                plugins={true}
                // mood={"multi"}
                inputSize={"md"}
              ></DatePiker>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail2">
              <CustomInput
                onChangeFunc={(e) => {
                  setReminderText(e.target.value);
                }}
                label={"متن یاد آور "}
                placeholder={"متن"}
                inputType="input"
                type="text"
                labelClassName="text-dark fs-6"
                inputValue={reminderText}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            لغو
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              reminder(value, reminderText);
            }}
          >
            ذخیره
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
